module.exports = __webpack_public_path__ + "img/Ktirio-Perama.cfec72cd.jpg";